import request from "@/utils/request";
export default {
  // RMC菜类采购量-列表查询
  findListPage: (param) => {
    return request({
      url: `/rmc/produce/purchase/findListPage`,
      method: "post",
      data: param,
    });
  },
  // RMC菜类采购量-详情维护（type:SAVE/DELETE/SUBMITTED）
  updateProteinPurchase: (param) => {
    return request({
      url: `/rmc/produce/purchase/updateProducePurchase`,
      method: "post",
      data: param,
    });
  },
  // 批量删除
  beatchDeletePurchase: (param) => {
    return request({
      url: `/rmc/produce/purchase/beatchDeletePurchase`,
      method: "post",
      data: param,
    });
  },
  // Farm农场主数据分页查询
  getFarm: () => {
    return request({
      url: `/rmc/produce/purchase/getFarm`,
      method: "get",
      data: {},
    });
  },
  // farm主数据查询
  findFarmList: (param) => {
    return request({
      url: `/rmc/produce/purchase/findFarmList`,
      method: "post",
      data: param,
    });
  },
  // Facility列表查询
  findFacility: (param) => {
    return request({
      url: `/rmc/protein/purchase/findFacility`,
      method: "post",
      data: param,
    });
  },
  // Sponsor列表查询
  findSponsor: (param) => {
    return request({
      url: `/rmc/produce/purchase/findSponsor`,
      method: "post",
      data: param,
    });
  },
  // 每个月X号，创建供应商上个月Produce采购量清单
  createLastMonthPurchase: () => {
    return request({
      url: `/rmc/produce/purchase/createLastMonthPurchase`,
      method: "get",
      data: {},
    });
  },
  // 下拉框列表
  getSelection: (param) => {
    return request({
      url: `/downloadList`,
      method: "post",
      data: param,
    });
  },
  // 列表导出
  rmcProducePurchaseDownload: (param) => {
    return request({
      url: `/rmc/produce/purchase/rmcProducePurchaseDownload`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // // RMC采购量模板导出
  // rmcProducePurchaseTempDownload: () => {
  //   return request({
  //     url: `/rmc/produce/purchase/rmcProducePurchaseTempDownload`,
  //     data: {},
  //     method: "fet",
  //     responseType: "blob",
  //     fullResponse: true,
  //   });
  // },
  // Produce采购量维护导出
  rmcProducePurchaseExport: (param) => {
    return request({
      url: `/rmc/produce/purchase/rmcProducePurchaseExport`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
};
